export default "__VITE_ASSET__DGipc1kW__"